module.exports = __webpack_public_path__ + "uy.svg?4bb9aa45c6f84caeb86e9ab430044489";